import type {
  LinksFunction,
  LoaderFunctionArgs,
  MetaFunction,
} from 'react-router';

import { JaneGoldRouteComponent } from '@jane/bloom/components/routes/janeGold/janeGoldRouteComponent';
import { loadJaneGoldRoute } from '@jane/bloom/loaders/routes/janeGold.server';
import { janeGoldRouteMeta } from '@jane/bloom/resources/meta/routes/janeGold';
import { plpStylesLinks } from '@jane/bloom/resources/plpStylesLinks';

export const links: LinksFunction = () => [...plpStylesLinks];

export const meta: MetaFunction<typeof loader> = (args) => {
  return janeGoldRouteMeta(args);
};

export { productGridShouldRevalidate as shouldRevalidate } from '@jane/bloom/utils/routes/shouldRevalidate';

export const loader = async (args: LoaderFunctionArgs) =>
  loadJaneGoldRoute({
    args,
    shouldPinStore: Boolean(args.params['storeSlug']),
  });

export default JaneGoldRouteComponent;
